var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
const { Heading, NavigationBar, NavigationBarItem } = require('@metro-ui/core');
var { Back } = require('@metro-ui/icons');

class LoginPreferencesNavigationBar extends React.Component {
    constructor(props) {
        super(props);

        this.onNavBarClick = this.onNavBarClick.bind(this);
    }

    onNavBarClick() {
        this.props.onNavItemClick();
    }

    render() {
        return (
            <NavigationBar onClick={this.onNavBarClick} className="navigation-bar">
                <NavigationBarItem position="left">
                    {this.props.headingText && <Back
                        className="login-prefs-back-button"
                        color="metro-blue"
                        hasNoInteractionEffect
                        size={1} />}
                    <Heading
                        className="login-prefs-nav-heading"
                        variant="h2">
                        {this.props.headingText}
                    </Heading>
                </NavigationBarItem>
            </NavigationBar>
        )
    }
}

module.exports = injectIntl(LoginPreferencesNavigationBar)